import { Navigate, useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { useAdminAccess } from './AdminAccessProvider';
import { AdminSignInForm } from './AdminSignInForm';
import '../proshop/proshop.css';

export const AdminAccessGate = () => {
  const navigate = useNavigate();
  return <main className="min-h-screen flex items-center justify-center bg-[var(--ps-bg-base)] p-5" data-testid="admin-access-page">
    <section className="course-workspace !max-w-md !p-0">
      <Shield size={34} className="text-green-600 mb-5" aria-hidden="true" />
      <h1>Admin access</h1>
      <p className="course-subtle mb-7" data-testid="admin-access-description">Par Seeker dashboard &amp; Pro Shop</p>
      <AdminSignInForm />
      <Button variant="ghost" className="mt-5" onClick={() => navigate('/dashboard')} data-testid="admin-access-back"><ArrowLeft size={16} className="mr-2" />Back to app</Button>
    </section>
  </main>;
};

export const AdminAccessBoundary = ({ children, entryPath }) => {
  const { isAuthenticated } = useAdminAccess();
  return isAuthenticated ? children : entryPath ? <Navigate to={entryPath} replace /> : <AdminAccessGate />;
};